import React from "react";
import clsx from "clsx";
import styled from "styled-components";

const NotFound = ({ className }) => {
  const baseClassName = clsx("notFound", className);
  return (
    <div className={baseClassName}>
      <h2>404 - Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

const StyledCompanyTimeline = styled(NotFound)`
&.notFound{
  padding: 40px;
  background: transparent; 
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}`;

export default StyledCompanyTimeline;
